import { render, staticRenderFns } from "./ValidacionEmail.vue?vue&type=template&id=92228416&scoped=true&"
import script from "./ValidacionEmail.vue?vue&type=script&lang=js&"
export * from "./ValidacionEmail.vue?vue&type=script&lang=js&"
import style0 from "./ValidacionEmail.vue?vue&type=style&index=0&id=92228416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92228416",
  null
  
)

export default component.exports